/*
 * Login module. Handles the user log in
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { ComponentsModule } from 'app/shared/components/components.module';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import { CustomUiConfigLoginComponent } from './custom-ui-config-login/custom-ui-config-login.component';
import { ForgotPasswordComponent } from "app/features/login/forgot-password/forgot-password.component";
import { MfaOnboardingComponent } from './mfa-onboarding/mfa-onboarding.component';

@NgModule({
  declarations: [
    LoginComponent,
    CustomUiConfigLoginComponent,
    ForgotPasswordComponent,
    MfaOnboardingComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule,
    ComponentsModule,
    DirectivesModule,
    ReactiveFormsModule
  ]
})
export class LoginModule {}
